export enum MenuClickSource {
  Menu = 'menu',
  QuickAccess = 'quick_access',
}
